import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';


const Contact = () => (
    <Card className="mt-3 mb-3">
        <Card.Header>Contact Information</Card.Header>
        <Card.Body>
            <Row>
                <Col xs={6} md={6} lg={6}>
                    <h3>Email:</h3>
                    <a href='mailto:tjdvse@rit.edu'>tjdvse@rit.edu</a>
                    <br/>
                    Email is the best and most reliable way to contact me.
                    <br/>
                    <br/>

                    <h3>Office Hours:</h3>
                    GOL (70) - 1559
                    <br/>
                    Monday, 11:15am - noon, or by appointment.
                </Col>

                <Col xs={6} md={6} lg={6}>
                    <h3>Address</h3>
                    <i>Department of Software Engineering</i><br/>
                    GOL 70-1559<br/>
                    Rochester Institute of Technology<br/>
                    134 Lomb Memorial Drive<br/>
                    Rochester, NY 14623
                </Col>
            </Row>
        </Card.Body>
    </Card>
);


export default Contact;
